import { render, staticRenderFns } from "./ServiceCatalogDetails.vue?vue&type=template&id=58ce3464&scoped=true"
import script from "./ServiceCatalogDetails.vue?vue&type=script&lang=js"
export * from "./ServiceCatalogDetails.vue?vue&type=script&lang=js"
import style0 from "./ServiceCatalogDetails.vue?vue&type=style&index=0&id=58ce3464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce3464",
  null
  
)

export default component.exports